import { schemes, zSchema } from "@zeal/common";

export const getFinixMerchantRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  testMode: zSchema.boolean().optional(),
});

export type TGetFinixMerchantRequestSchema = zSchema.infer<
  typeof getFinixMerchantRequestSchema
>;

export const getFinixMerchantResponseSchema = zSchema.any();

export type TGetFinixMerchantResponseSchema = zSchema.infer<
  typeof getFinixMerchantResponseSchema
>;
